// The address of the Microsoft sign-in, which sends the person back to /auth/oauth2process and from there on to returnPath.
// Used by the sign-in page of the current site and the one of V2.
export const CLIENT_ID = 'a38dc3ea-2542-4fe7-bda5-7af172d33f81';

export const loginUrl = (returnPath = '/home', origin = window.location.origin) => {
  const nonce = crypto.getRandomValues(new Uint32Array(1))[0];
  const redirectUri = `${origin}/auth/oauth2process`;
  const state = encodeURIComponent(returnPath || '/home');
  return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${CLIENT_ID}&response_type=id_token code&redirect_uri=${redirectUri}&response_mode=fragment&scope=user.read profile openid offline_access&state=${state}&nonce=${nonce}`;
};
